import { INotification } from '../../commons/interfaces/notification.interface';
import NotificationItem from '../NotificationItem';
import './style.scss';

interface NotificationListProps {
  notifications: INotification[];
  onNotificationClick: (notification: INotification) => void;
  showShowMore: boolean;
  showMoreClick: () => void;
}

const NotificationList = ({
  notifications,
  onNotificationClick,
  showShowMore,
  showMoreClick
}: NotificationListProps) => {
  return (
    <div>
      {notifications.map((notification) => (
        <NotificationItem
          key={notification.id}
          notification={notification}
          onClick={onNotificationClick}
        />
      ))}
      {showShowMore && (
        <div className="d-flex justify-content-center my-2">
          <span className="clickeable" onClick={showMoreClick}>
            Ver más
          </span>
        </div>
      )}
    </div>
  );
};

export default NotificationList;
